import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched } from 'formik';

export interface AnnullamentVM {
  note?: string;
}

interface FormProps {
  disabled?: boolean;
  onChange: (key: keyof AnnullamentVM, value: AnnullamentVM[keyof AnnullamentVM]) => void;
  values?: AnnullamentVM;
  errors?: FormikErrors<AnnullamentVM>;
  touched?: FormikTouched<AnnullamentVM>;
}

const FormComponent = ({
  disabled = false,
  onChange,
  values,
  errors,
  touched,
}: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PmiTextField
          label="Nota annullamento *"
          aria-label="Nota annullamento"
          id="note"
          fullWidth
          inputProps={{
            maxLength: '240',
          }}
          multiline
          rows={3}
          value={values?.note || ''}
          onChange={(event) => onChange('note', event.target.value)}
          disabled={disabled}
          error={touched?.note && Boolean(errors?.note)}
          helperText={errors?.note}
        />
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Form annullament';

const Form = memo(FormComponent);

export default Form;
